import Money from "../core/Money";
import {BasketItemInterface} from "../../interfaces/checkout/BasketItemInterface";
import useComparison from "../../utils/useComparison";
import useFavorite from "../../utils/useFavorite";
import {useContext} from "react";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {GlobalContext} from "../../GlobalReducer";
import {Link} from "react-router-dom";

export default function BasketItem({basketItem}: { basketItem: BasketItemInterface }) {
    const {inComparison, toggleComparison} = useComparison(basketItem.product);
    const {inFavorites, toggleFavorite} = useFavorite(basketItem.product);
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);


    const setQuantity = (newQuantity: number) => {
        const newBasketItem = {...basketItem, quantity: newQuantity}
        const currentBasket = state.basket.map(item => {
            if (item.product.id === basketItem.product.id) {
                return newBasketItem
            }
            return item
        })
        dispatch({type: 'SET_BASKET', payload: currentBasket})
    }

    const removeFromBasket = () => {
        dispatch({type: 'REMOVE_FROM_BASKET', payload: basketItem.product})
    }

    const getCurrentTotal = () => {
        return {amount: ((basketItem.product.client_price || basketItem.product.current_price).amount * basketItem.quantity), currency: (basketItem.product.client_price || basketItem.product.current_price).currency}
    }

    const getBaseTotal = () => {
        return {amount: ((basketItem.product.client_base_price || basketItem.product.base_price).amount * basketItem.quantity), currency: (basketItem.product.client_base_price || basketItem.product.base_price).currency}
    }

    return (<div className="prod-card">
        <div className="d-flex prod-card__content">
            <div className="prod-card__top">
                <Link to={`/catalog/item/${basketItem.product.catalog_code}/${basketItem.product.id}/${basketItem.product.human_url}`} className="prod-card__img-box">
                    <div id="prodCardSlider1" className="carousel carousel-prod-card slide">
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <picture>
                                    <img src={'https://www.pride.ru' + basketItem.product?.additional_params?.list_image_path} className="w-auto d-block h-auto m-auto" alt={basketItem.product.name}/>
                                </picture>
                            </div>

                        </div>
                    </div>
                </Link>
            </div>

            <div className="d-flex flex-column align-items-start prod-card__body">
                <div
                    className="d-flex align-items-center justify-content-between g-3 prod-card__head">
                    <p className="t-gray fw-medium m-0 prod-card__h-text">код: {basketItem.product.code}</p>
                    <div className="d-flex align-items-center prod-card__i-row">
                        <div className={"prod-card__h-i prod-card__h-i-like " +  (inFavorites() && '_active')} onClick={() => {
                            if (!basketItem.product.id.toString()) return
                            toggleFavorite()
                        }}></div>
                        <div className={"prod-card__h-i prod-card__h-i-stat "  + (inComparison() && '_active')} onClick={() => {
                            if (!basketItem.product.id.toString()) return
                            toggleComparison()
                        }}></div>
                        <div className="prod-card__close" onClick={removeFromBasket}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M17.9992 18.1681L1.05469 1.22363M17.9992 1.22363L1.05469 18.1681"
                                    stroke="#898A8C" stroke-width="2.11806" stroke-linecap="round"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div className="prod-card__text prod-card__title t-elips-3"><Link to={`/catalog/item/${basketItem.product.catalog_code}/${basketItem.product.id}/${basketItem.product.human_url}`}>{basketItem.product.name}</Link></div>
                {basketItem.product.has_client_stock && <p className="prod-card__text fw-bold t-green">В наличии, {basketItem.product.client_smart_stock}</p>}
                {!basketItem.product.has_client_stock && <p className="prod-card__text fw-bold text-danger">Нет в наличии</p>}
                <div
                    className="d-flex flex-column flex-md-row align-items-md-center justify-content-between prod-card__bot">
                    <p className="prod-card__text">
                        <span className="t-gray">Артикул:</span> {basketItem.product.articul}
                    </p>
                    <div className="d-flex align-items-center prod-card__bot-row">
                        <div className="d-flex flex-wrap prod-card__price">
                            {(basketItem.product.client_base_price || basketItem.product.base_price).amount > (basketItem.product.client_price || basketItem.product.current_price).amount &&
                                <p className="prod-card__text fw-medium t-gray text-decoration-line-through"><Money value={getBaseTotal()}/></p>}
                            <div className="d-flex flex-column prod-card__price-row">
                                <p className="prod-card__text fw-bold big t-orange"><Money value={getCurrentTotal()}/></p>
                                {basketItem.quantity > 1 && <p className="prod-card__text min"><Money value={basketItem.product.client_price || basketItem.product.current_price}/> / шт.</p>}
                            </div>
                        </div>
                        {basketItem.product.has_client_stock && <div className="quantity">
                            <div className="quantity__row">
                                <button className="quantity__number-minus" type="button" onClick={() => {
                                    if (basketItem.quantity > 1) {
                                        setQuantity(basketItem.quantity - 1)
                                    }
                                }}>
                                    -
                                </button>
                                <input type="number" min="1" value={basketItem.quantity}
                                       className="quantity__input" onChange={(e) => {
                                    setQuantity(parseInt(e.target.value) || 1)
                                }}/>
                                <button className="quantity__number-plus" type="button" onClick={() => {
                                    setQuantity(basketItem.quantity + 1)
                                }}>
                                    +
                                </button>
                            </div>
                        </div>}
                    </div>

                </div>
            </div>
        </div>
    </div>);
}